<template>
    <v-dialog
        v-model="$store.state.dispatch.confirmWindow"
        hide-overlay
        persistent
        max-width="350px"
        transition="dialog-bottom-transition"
    >
        <v-card>
            <v-card-title>{{ Title }}</v-card-title>
            <v-card-text>{{ Message }}</v-card-text>
            <div
                style="display: flex;justify-content: space-between;padding: 0 15px 15px 15px;"
            >
                <v-btn color="primary" @click="functionList">
                    {{ ConfirmText }}
                </v-btn>
                <v-btn
                    text
                    @click="$store.state.dispatch.confirmWindow = false"
                >
                    Cancel
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
    props: ['Title', 'Message', 'ConfirmText', 'Type', 'ShiftDispatchFinalize'],
    components: {},
    data: function() {
        return {
            //variables: [],
            //here: true,
            //...
        };
    },
    mounted() {
        //this.functionsForMountedHere();
    },
    methods: {
        functionList: function() {
            switch (this.Type) {
                case 'dispatchFinalize':
                    this.dispatchFinalize();
                    break;
                default:
                    console.log('No event type');
            }
        },
        dispatchFinalize: async function() {
            var str = this.$store;
            let shiftDetail = this.ShiftDispatchFinalize.ShiftDetail;
            let status = this.ConfirmText == 'Open Shift' ? 0 : 1;
            let params = {
                ShiftDetail: shiftDetail,
                Status: status
            };

            console.log(params);
            this.$store.state.isLoading = true;
            await axios
                .post('shift-detail/dispatch-finalize', params)
                .then(response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Shift Updated!'
                    });
                    this.$emit(
                        'close',
                        'dispatchFinalize',
                        shiftDetail,
                        status
                    );
                    this.$store.state.dispatch.confirmWindow = false;
                })
                .catch(error => {
                    console.log(error);
                    str.state.isLoading = false;
                    str.dispatch('setSnackbar', {
                        color: 'error',
                        text:
                            'Something is wrong. Please contact the administrator.'
                    });
                    this.$store.state.dispatch.confirmWindow = false;
                });
        }
    }
};
</script>

<style>
/* Styles here */
</style>
